import r from './core';
import user from './libs/user';
import profile from './libs/profile';
import video from './libs/video';
import videos from './libs/videos';
import community from './libs/community';
import tracker from './libs/tracker';

export default {
  user,
  profile,
  community,
  video,
  videos,
  tracker,

  sendLead(formData, callback) {
    const appKey = 'AKfycbyprgTvl6zgLeAfVepeyOXIvpt6nWYkNWQU1krw8ikC3XMuRMg';
    const options = {
      url: `https://script.google.com/a/viddsee.com/macros/s/${appKey}/exec`,
      params: {
        options: JSON.stringify(formData),
      },
    };
    return r.post(options, callback, false);
  },

  // Actions bar
  getUserVideoRating(options, callback) {
    options.url = API_URL + 'video/' + options.video_id + '/rating';
    return r.get(options, callback);
  },

  postUserVideoRating(options, callback) {
    options.url = API_URL + 'video/' + options.video_id + '/rating';
    return r.post(options, callback);
  },

  getUserVideoQueueStatus(options, callback) {
    options.url = API_URL + 'video/' + options.video_id + '/queue';
    return r.get(options, callback);
  },

  postQueueVideo(options, callback) {
    options.url = API_URL + 'queue/' + options.video_id;
    options.param = {};
    return r.post(options, callback);
  },

  postUnqueueVideo(options, callback) {
    options.url = API_URL + 'unqueue/' + options.video_id;
    options.param = {};
    return r.post(options, callback);
  },

  // Navbar
  getAutocompleteSearchResults(options, callback) {
    options.url = API_URL + 'search/autocomplete';
    options.params = {};
    options.params.search_string = options.search_string;
    return r.get(options, callback);
  },

  // Feedback
  postSupport(options, callback) {
    options.url = API_URL + 'support';
    return r.post(options, callback);
  },

  // Other
  getLinkPreview(options, callback) {
    options.url = API_URL + 'preview_link?url=' + options.url;
    return r.get(options, callback);
  },
};
